module.exports = __webpack_public_path__ + "img/step19_b_remove_left-right_stacker_adaptor-box.c9346f46.png";